import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/lm.css'
import './assets/css/style.css'

import { createHead } from '@vueuse/head' // ✅ import

const app = createApp(App)
const head = createHead()

app.use(router)
app.use(head) // ✅ dodaj plugin do aplikacji
app.mount('#app')
